/** @type {HTMLDivElement | undefined} */
let region;

/**
 * @typedef {object} Options
 * @property {"polite" | "assertive"} [level ="polite"] Default is `"polite"`
 */

/**
 * A small function to make screen readers announce text. Loosely based on
 * https://github.com/Heydon/on-demand-live-region
 *
 * @param {string} text
 * @param {Options} options
 */
export default function announce(text, options) {
	const { level = "polite" } = options;

	// remove any previous live region
	if (region) document.body.removeChild(region);

	// create a new live region element
	region = document.createElement("div");
	region.setAttribute("aria-live", level);

	// hide live region element, but not from assistive technologies
	region.setAttribute(
		"style",
		"clip: rect(1px, 1px, 1px, 1px); height: 1px; overflow: hidden; position: absolute; top: 0; white-space: nowrap; width: 1px",
	);

	// add live region to the DOM
	document.body.appendChild(region);

	// populate live region to trigger it
	setTimeout(() => {
		if (region) region.textContent = text;
	});
}
